import * as layouts from "./index";
import { PageConfig } from "../types/types";
import React from "react";
import { StandardProps } from "../components/componentMap";

export type LayoutProps = {
  pageConfig: PageConfig;
} & StandardProps;

type Layout = (props: LayoutProps) => React.ReactNode;

type LayoutMap = { [name: string]: Layout };

export const layoutMap: LayoutMap = layouts;
